'use strict';

function findParentForm(element) {
  var parentNode = element.parentNode;

  if (!parentNode || parentNode.nodeName === 'FORM') {
    return parentNode;
  }

  return findParentForm(parentNode);
}

module.exports = {
  findParentForm: findParentForm
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/braintree-web-drop-in/lib/find-parent-form.js
// module id = ljaz
// module chunks = 3